import './Button.scss'

import { Spinner } from '@tallink/components-lib'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

export default function Button({
  children,
  className = 'button-default',
  disabled,
  name,
  processing,
  onClick,
  rounded,
  type = 'submit'
}) {
  return (
    <button
      className={classNames(className, { processing, rounded })}
      disabled={disabled}
      name={name}
      onClick={onClick}
      type={type}
    >
      {children}
      {processing && <Spinner />}
    </button>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func,
  processing: PropTypes.bool,
  rounded: PropTypes.bool,
  type: PropTypes.string
}
